import "../styles/rules.scss";

export const Rules = () => {

    return (
        
         <div className="rules">
            <div className="rules__header" >
                 <h2>Правила аукциона</h2>
            </div>
             <div className="rules__content" align="left"> 
                <p>
                    Смотрите лоты и выбирайте любой понравившийся автомобиль. Подробнее с правилами аукциона вы можете ознакомиться в <br/> 
                    <a href="https://disk.yandex.ru/i/2yDKSket9CdAGg" target="_blank" rel="noopener noreferrer"> Пользовательском соглашении </a> <br/> 
                    <a href="https://disk.yandex.ru/i/Ntn1YAKwG4WcVQ" target="_blank" rel="noopener noreferrer"> Согласии на обработку персональных данных </a> 
                </p>
                <p>
                    Часто задаваемые вопросы:<br/> 
                    <a href="#question1" >Как сделать ставку?</a><br/> 
                    <a href="#question2" >Сколько длится аукцион?</a><br/> 
                    <a href="#question3" >Как добавить лот в избранное?</a><br/> 
                    <a href="#question4" >Можно ли отменить ставку?</a><br/> 
                    <a href="#question5" >Как определяется победитель?</a><br/> 
                    <a href="#question6" >Бронирование автомобиля</a><br/> 
                    <a href="#question7" >Способы оплаты</a><br/> 
                    <a href="#question8" >Отказ от лота</a>
                </p> 
                <p> 
                    В случае нарушения одного из правил аукционной площадки пользователь получает предупреждение. После двух предупреждений пользователь блокируется. 
                    Срок первой блокировки составляет 30 дней, после чего пользователь может обратиться к администратору аукциона (@borauto_auction) и восстановить доступ. При повторном нарушении срок блокировки увеличивается до 90 дней, третья блокировка является бессрочной.
                    Пользователь может получить предупреждение в случае:<br/>
                    1. Необоснованного отказа от приобретения автомобиля или отсутствия подтверждающих материалов о наличии дефекта, не указанного в лоте.<br/> 
                    2. Неподтверждение ставки в течение часа (для лотов, переданных в течение 24 часов с момента начала торгов).<br/> 
                    3. Неявка на осмотр автомобиля в течение 7 дней с момента подтверждения ставки.<br/> 
                    4. Удержания окна подтверждения ставки дольше 20 секунд, а также отмены подтверждения и нажатия на него ещё раз.<br/> 
                    5. Накручивания ставок (распространяется на всех пользователей, участвовавших в накрутке и отказавшихся от приобретения автомобиля).<br/> 
                    6. Размещения автомобиля в продажу на Авито, Авто.ру и др. площадки до момента его покупки (блокировка вне зависимости от количества предупреждений).
                </p> 
                <section id="question1" className="rules__section">
                    <h4> Как сделать ставку? </h4>
                    <p>
                        Делая ставку, участник подтверждает желание и возможность купить автомобиль. 
                        На лоте есть стартовая цена, чтобы сделать ставку нажмите на кнопку «+4000 ₽», подтвердите ее, 
                        после этого вы увеличите цену на 4 000 рублей. Чтобы сделать ставку на ночной аукцион, нужно 
                        написать администратору аукциона @borauto_auction свою окончательную цену, по которой вам интересно выкупить автомобиль. 
                        Если ваша ставка останется максимальной, победа ваша! Ставку нужно обязательно подтвердить в чате с модератором аукциона, 
                        в противном случае ДЦ вправе отказать проводить сделку. Если лот был вам передан в день розыгрыша, любой отказ от ставки 
                        является необоснованным и влечет за собой предупреждение о нарушении правил аукционной площадки.
                    </p>  
                </section>
                <section id="question2" className="rules__section">
                    <h4> Сколько длится аукцион? </h4>
                    <p> Чтобы узнать, когда закончится аукцион, необходимо открыть карточку аукциона, где указана дата и время окончания аукциона. Последняя ставка автоматически продлевает розыгрыш на 5 минут.</p>
                </section>
                <section id="question3" className="rules__section">
                    <h4> Как добавить лот в избранное? </h4>
                    <p> Чтобы добавить лот в избранное необходимо нажать пиктограмму ☆ в карточке лота.</p>
                </section>
                <section id="question4" className="rules__section">
                   <h4> Можно ли отменить ставку? </h4>
                   <p> Отменить ставку нельзя. За отказ от ставки пользователь получает предупреждение.</p>
                </section>
                <section id="question5" className="rules__section">
                    <h4> Как определяется победитель? </h4>
                    <p> Лот передается пользователю, чья ставка лидирует на момент окончания аукциона. Если победитель аукциона не подтверждает ставку в течение одного часа - автомобиль передаётся следующему участнику.</p>
                </section>
               <section id="question6" className="rules__section">
                   <h4> Бронирование автомобиля </h4>
                   <p> 
                        Бесплатная бронь на автомобиль закрепляется за победителем на 2 суток. 
                        Срок бронирования автомобиля по предоплате составляет 7 дней. 
                        Размер предоплаты устанавливается дилерским центром. Увеличение срока бронирования возможно по согласованию с дилерским центром. 
                        Дилер вправе отказать в бронировании на срок более 7 дней и передать лот следующему участнику.
                    </p>  
                </section>
                <section id="question7" className="rules__section">
                   <h4> Способы оплаты </h4>
                   <p> 
                        - Наличные <br/>
                        - Безнал (QR-код) <br/>
                        - Эквайринг (оплата автомобиля картой производится только по предварительному согласованию с модератором аукциона @borauto_auction) <br/>  
                        - Кредит 
                    </p>
                </section>
                <section id="question8" className="rules__section">
                   <h4> Отказ от лота </h4>
                   <p> 
                        Вы можете отказаться от автомобиля, если при осмотре был обнаружен дефект, информации о котором не было в лоте 
                        (дефект не указан в описании или нет его фото). Для подтверждения отказа необходимо предоставить фото/видео выявленного дефекта. 
                        О подобных ситуациях просим сообщать модератору аукциона @borauto_auction, чтобы мы помогли разобраться в ситуации. 
                        В остальных случаях отказы будут считаться необоснованными. В случае необоснованного отказа пользователь получает предупреждение.
                    </p>
                </section>
            </div>
        </div>
        
    ) 
}